import { axiosB2 } from './axiosB2';

/**
 * Create a Mailchimp list via B2 REST.
 * Proxy equivalent: POST /mailchimp/list (plain-text list name body).
 * B2 SOAP action: CreateMailChimpList
 *
 * @param {string} listName
 * @returns {Promise<string>} Created Mailchimp list id
 */
export function createMailChimpList(listName) {
    return axiosB2.post('CreateMailChimpList', { listName }).then(({ data }) => {
        const parsed = typeof data === 'string' ? JSON.parse(data) : data;
        if (parsed == null) {
            throw new Error('Empty B2 response');
        }
        const state = parsed.State ?? parsed.state;
        if (state !== undefined && state !== null && state !== '1' && state !== 1) {
            const msg = parsed.Message || parsed.message || 'B2 error';
            throw new Error(typeof msg === 'string' ? msg : 'B2 error');
        }
        const result = parsed.Result ?? parsed.result;
        if (!result) {
            throw new Error('Empty Mailchimp list id');
        }
        return result;
    });
}
